(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  let state = null;
  let pending = 0;
  let refreshTimer;
  const panels = () => Array.from(document.querySelectorAll('[data-av-cart-reassurance]'));
  const nativeCheckout = () => document.querySelector('#cart_form [data-cart-checkout-button]');
  function money(cents, currency) {
    return new Intl.NumberFormat('en-US', {style:'currency', currency:currency || 'USD'}).format(cents / 100);
  }
  function render(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    state = cart;
    const active = true;
    const usd = cart.currency === 'USD';
    const eligible = usd && active && cart.total_price >= 6000;
    panels().forEach(panel => {
      panel.dataset.total = cart.total_price;
      panel.dataset.count = cart.item_count;
      panel.querySelector('[data-av-shipping]').textContent = usd ? (eligible ? 'FREE' : '$4.99') : 'Calculated at checkout';
      const promo = panel.querySelector('[data-av-promotion]');
      promo.hidden = !active;
      promo.textContent = usd ? (eligible ? 'Free standard shipping unlocked for the contiguous U.S.' : 'Add ' + money(6000-cart.total_price, 'USD') + ' for free standard shipping.') : 'Free standard shipping on US$60+ orders to the contiguous U.S.';
      panel.querySelector('[data-av-promo-terms]').hidden = !active;
    });
    document.querySelectorAll('[data-av-sticky-subtotal]').forEach(el => {el.textContent=money(cart.total_price,cart.currency);});
    document.querySelectorAll('[data-av-sticky-shipping]').forEach(el => {el.textContent=usd ? (eligible ? 'Free standard shipping · 48 states + D.C.' : 'Standard shipping $4.99 · 48 states + D.C.') : 'Shipping calculated at checkout';});
    document.querySelectorAll('.js-cart_subtotal .money').forEach(el => {el.textContent=money(cart.total_price,cart.currency);});
    syncSticky();
  }
  function syncSticky() {
    const button = nativeCheckout();
    const bar = document.querySelector('[data-av-sticky]');
    if (!bar || !button) return;
    const count = state?.item_count ?? Number(panels()[0]?.dataset.count || 0);
    const rect = button.getBoundingClientRect();
    const visible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    bar.hidden = count === 0 || visible;
    bar.querySelector('[data-av-sticky-checkout]').disabled = pending > 0 || button.disabled || button.classList.contains('disabled');
  }
  async function refresh() {
    try {
      const response = await fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
      if (response.ok) render(await response.json());
    } catch (_) { /* Existing checkout remains available if reassurance cannot refresh. */ }
  }
  function queueRefresh() {clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,100);}
  function start() {
    const first = panels()[0];
    if (first) render({total_price:Number(first.dataset.total),item_count:Number(first.dataset.count),currency:first.dataset.currency});
    document.querySelector('[data-av-sticky-checkout]')?.addEventListener('click', () => {
      const button = nativeCheckout();
      if (button && !button.disabled && pending === 0) button.click();
    });
    if (window.jQuery) {
      const jq = window.jQuery;
      const isCart = options => /\/cart(?:\/(?:add|change|update))?\.js(?:\?|$)/.test(options.url || '');
      jq(document).ajaxSend((_event,_xhr,options) => {if(isCart(options) && /\/(add|change|update)\.js/.test(options.url)){pending++;syncSticky();}});
      jq(document).ajaxSuccess((_event,xhr,options) => {
        if (!isCart(options)) return;
        const data = xhr.responseJSON;
        if (data && Array.isArray(data.items) && typeof data.total_price === 'number') render(data);
        else queueRefresh();
      });
      jq(document).ajaxComplete((_event,_xhr,options) => {if(isCart(options) && /\/(add|change|update)\.js/.test(options.url)){pending=Math.max(0,pending-1);syncSticky();}});
    }
    document.addEventListener('change', event => {
      if (!event.target.matches('[data-cart-quantity-input]')) return;
      // Supplement themes/apps that suppress global jQuery completion events.
      setTimeout(refresh, 800);
      setTimeout(() => {
        const quantity = Array.from(document.querySelectorAll('#cart_form [data-cart-quantity-input]')).reduce((sum,input)=>sum+Number(input.value),0);
        if (state && quantity !== state.item_count) refresh();
      }, 2200);
    });
    const button = nativeCheckout();
    if (button) new MutationObserver(syncSticky).observe(button,{attributes:true,attributeFilter:['disabled','class']});
    window.addEventListener('scroll',syncSticky,{passive:true});
    window.addEventListener('resize',syncSticky,{passive:true});
    window.addEventListener('pageshow',queueRefresh);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden) queueRefresh();});
    refresh();
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();